import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SystemIntro } from './components/SystemIntro';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel, trackPixelEventOnce, PRODUCT_EVENT_PARAMS } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEventOnce('ViewContent', PRODUCT_EVENT_PARAMS);
  }, []);
  return <div className="w-full min-h-full bg-charcoal font-body text-cream" data-id="element-0" data-mp="23ujha3i1d6za">
      <Hero data-id="element-1" data-mp="3ikqyfyb7r257" />
      <main data-id="element-2" data-mp="3iiwasc8k4vxf">
        <Problems data-id="element-3" data-mp="3ijfv1zlojwem" />
        <SystemIntro data-id="element-4" data-mp="3ihv0i9zd8dgr" />
        <Modules data-id="element-5" data-mp="3mlj6io8cn0zw" />
        <Bonuses data-id="element-6" data-mp="3ml17jjuay8oa" />
        <Transformation data-id="element-7" data-mp="3mkhofzsx1e8o" />
        <Pricing data-id="element-8" data-mp="3mjq3rk0ux0x6" />
        <Guarantee data-id="element-9" data-mp="3mj6j3vjtnyfg" />
        <Testimonials data-id="element-10" data-mp="3rcj31sdk3h1v" />
        <Faq data-id="element-11" data-mp="3rdaq2et386gj" />
        <FinalClose data-id="element-12" data-mp="3rdkkqfp2v1sk" />
      </main>
      <Footer data-id="element-13" data-mp="3relvej26lm9r" />
      <PurchaseNotifications data-id="element-14" data-mp="5ot150vj28n" />
    </div>;
}